import React, { useEffect, useState, useContext, useRef } from "react";
import TeacherCard from "./TeachersCard/TeacherCard";
import TeachersFilter from "./TeachersFilter/TeachersFilter";
import Col from "../../UIcomponent/Column";
import "./TeachersList.scss";
import InfiniteScroll from "react-infinite-scroller";
import TeachersListReq from "../../Utility/Requester/TeachersListReq";
import LocalContetxt from "../../Context/LocalContetxt";
import TeachersListDic from "./TeachersListDic";
import Wrapper from "../../UIcomponent/Wrapper";
import NoItemFound from "../../Component/NoItemFound";
import LocalBooking from "../../Utility/Method/LocalBooking";
import { Loader } from "../../UIcomponent/Loader";
import { Notify } from "../../UIcomponent/NotificationManager";
import Metas from "../../Component/Metas";
import FooterDescription from "../../Component/FooterDescription";
const TeachersList = (props) => {
  const [notificationMode, setNotificationMode] = React.useState(
    window.notificationOpen !== true
  );

  const initialParams = {
    QUERY: "",
    SortingBy: "",
    SortingOrder: 1,
    MinPrice: 0,
    MaxPrice: 200 * 10000,
    // Page: 0,
    // PageSize: 10,
  };
  const [params, setParams] = useState(initialParams);
  const [state, setState] = useState({
    activeFilter: "recently",
    query: "",
    hasPriceFilter: false,
    hasSortFilter: false,
    showPrice: false,
    Results: [],
    show: {
      priceSlider: false,
    },
    Paging: {
      Page: 0,
      PageSize: 0,
      Total: 0,
      HasNext: false,
    },
  });
  const [noItemFound, setNoItemFound] = useState(false);
  const [loading, setLoading] = useState(true);
  const lang = useContext(LocalContetxt).lang;
  const PageSize = 20;

  const getTeacherList = (Params) => {
    TeachersListReq.FindTeacher(Params)
      .then((res) => {
        let Results = res.data.Results.map((each) => {
          return {
            ...each,
            tab: 0,
            videoPlaying: false,
          };
        });
        setState({
          ...state,
          Results,
          Paging: { ...state.Paging, ...res.data.Paging },
        });
        setLoading(false);
        setNoItemFound(false);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    let PARAM = { ...initialParams };
    PARAM.PageSize = PageSize;
    getTeacherList(PARAM);
    LocalBooking.Remove();
  }, []);
  function onNotificationCollapse() {
    setNotificationMode(false);
  }
  React.useEffect((_) => {
    document.addEventListener("notificationCollapsed", onNotificationCollapse);
    return (_) =>
      document.removeEventListener(
        "notificationCollapsed",
        onNotificationCollapse
      );
  }, []);

  /* --- Lazy Load More --- */
  const loadMore = () => {
    let Params = {
      ...params,
      PageSize,
      Page: state.Paging.Page + 1,
    };
    TeachersListReq.FindTeacher(Params)
      .then((res) => {
        let Results = res.data.Results.map((each) => {
          return {
            ...each,
            tab: 0,
          };
        });
        setState({
          ...state,
          Results: [...state.Results, ...Results],
          Paging: res.data.Paging,
        });
      })
      .catch((err) => {});
  };

  /* --- Card video/description Tab Switcher --- */
  const TabHandle = (Index, i) => {
    let Results = [...state.Results];
    Results[Index].tab = i;
    setState({
      ...state,
      Results,
    });
  };
  const PlayingHandler = (id) => {
    let newResults = [...state.Results];
    // newResults = newResults.map((each) => {
    //     return ({
    //         ...each,
    //         videoPlaying: each.UserID === id ? true : false
    //     })
    // })
    // setState({
    //     ...state,
    //     Results: newResults
    // })
  };

  const RemoveFilter = () => {
    getTeacherList(initialParams);
  };
  return (
    // <Wrapper>
    <Col
      xl={16}
      lg={22}
      md={23}
      sm={24}
      xs={24}
      flexDir="column"
      justifyContent="flex-start"
      className={`l__TeachersList ${
        notificationMode ? "teacher_notificationMode" : ""
      }`}
    >
      <Metas
        title="منتخبی از اساتید زبان حرفه‌ای | لینگوتاک"
        description="منتخبی از بهترین اساتید زبان در لینگوتاک گرد هم جمع شده‌اند تا مسیر یادگیری و آموزش زبان را برای شما ساده‌تر کنند"
      />

      <TeachersFilter
        state={state}
        setState={setState}
        setNoItemFound={setNoItemFound}
        getList={getTeacherList}
        params={params}
        setParams={setParams}
        initialParams={initialParams}
        removeFilter={RemoveFilter}
      />

      <Col className="c__TeachersList__Title">
        {noItemFound === false && (
          <>
            <Col className="o__TeachersList__Title">
              {TeachersListDic.Title[`${lang}`]}
            </Col>
            <Col className="o__TeachersList__Title__Detail">
              {JSON.stringify(params) !== JSON.stringify(initialParams) &&
                "(" + state.Paging.Total + "مورد یافت شد" + ")"}
            </Col>
          </>
        )}
      </Col>

      <NoItemFound
        visible={noItemFound}
        actionTitle="حذف فیلتر"
        actionHandler={RemoveFilter}
      />
      <InfiniteScroll
        className="infiniteScroll"
        style={{
          display: noItemFound === true && "none",
        }}
        threshold={30}
        pageStart={0}
        initialLoad={false}
        loadMore={loadMore}
        hasMore={state.Paging.HasNext}
        // useWindow={true}
        loader={<Loader height={80} />}
        useWindow={true}
        // getScrollParent={() => this.scrollParentRef}
      >
        <TeacherCard
          loading={loading}
          state={state}
          setState={setState}
          TabHandle={TabHandle}
          PlayingHandler={PlayingHandler}
        />
      </InfiniteScroll>
      <FooterDescription
        title="با اساتید حرفه‌ای زبان لینگوتاک آشنا شوید"
        content="اساتید حرفه‌ای زبان لینگوتاک از میان تعداد زیادی از اساتید زبان انتخاب شده‌اند تا به شما در یادگیری هرچه بهتر و سریع‌تر زبان یاری برسانند. برای گرفتن بهترین نتیجه ممکن، با توجه به نیازهای آموزشی خود و براساس توانایی و سابقه اساتید، مناسب‌ترین استاد زبان را انتخاب کنید."
      />
    </Col>
    // </Wrapper>
  );
};

export default TeachersList;
